/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminWorkstreamImporterCreateRequest } from '../models/AdminWorkstreamImporterCreateRequest';
import type { AdminWorkstreamImporterCreateResponse } from '../models/AdminWorkstreamImporterCreateResponse';
import type { AdminWorkstreamImporterDebugExportResponse } from '../models/AdminWorkstreamImporterDebugExportResponse';
import type { AdminWorkstreamImporterDebugRequest } from '../models/AdminWorkstreamImporterDebugRequest';
import type { AdminWorkstreamImporterPreviewRequest } from '../models/AdminWorkstreamImporterPreviewRequest';
import type { AdminWorkstreamImporterPreviewResponse } from '../models/AdminWorkstreamImporterPreviewResponse';
import type { AdminWorkstreamImporterTimeframe } from '../models/AdminWorkstreamImporterTimeframe';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminWorkstreamImporterService {

    /**
     * List Workstream Import Timeframes
     * @returns AdminWorkstreamImporterTimeframe Successful Response
     * @throws ApiError
     */
    public static listWorkstreamImportTimeframesApiV1AdminWorkstreamImporterTimeframesGet(): CancelablePromise<Array<AdminWorkstreamImporterTimeframe>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/workstream-importer/timeframes',
        });
    }

    /**
     * Preview Workstream Import
     * @param requestBody
     * @returns AdminWorkstreamImporterPreviewResponse Successful Response
     * @throws ApiError
     */
    public static previewWorkstreamImportApiV1AdminWorkstreamImporterPreviewPost(
        requestBody: AdminWorkstreamImporterPreviewRequest,
    ): CancelablePromise<AdminWorkstreamImporterPreviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/workstream-importer/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Debug Workstream Import
     * @param requestBody
     * @returns AdminWorkstreamImporterDebugExportResponse Successful Response
     * @throws ApiError
     */
    public static debugWorkstreamImportApiV1AdminWorkstreamImporterDebugPost(
        requestBody: AdminWorkstreamImporterDebugRequest,
    ): CancelablePromise<AdminWorkstreamImporterDebugExportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/workstream-importer/debug',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Workstream Import
     * @param requestBody
     * @returns AdminWorkstreamImporterCreateResponse Successful Response
     * @throws ApiError
     */
    public static createWorkstreamImportApiV1AdminWorkstreamImporterCreatePost(
        requestBody: AdminWorkstreamImporterCreateRequest,
    ): CancelablePromise<AdminWorkstreamImporterCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/workstream-importer/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
